import { PayloadAction, createSlice } from '@reduxjs/toolkit'
import {
  fetchAllPlans,
  addPlan,
  removePlan,
  updatePlan,
} from '../actions/plan.action'
import { Plan, UpdatePlanThunkParams } from '@dataTypes/index'

type PlanState = {
  data: Plan[] | null
  loading: boolean
  error: null
}

const initialState: PlanState = {
  data: null,
  loading: false,
  error: null,
}

const plansSlice = createSlice({
  name: 'plans',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(
      fetchAllPlans.fulfilled,
      (state, action: PayloadAction<Plan[]>) => {
        state.data = action.payload
        state.loading = false
      },
    )
    builder.addCase(fetchAllPlans.pending, (state) => {
      state.loading = true
    })
    builder.addCase(fetchAllPlans.rejected, (state) => {
      state.error = null
      state.loading = false
    })

    builder.addCase(addPlan.fulfilled, (state, action: PayloadAction<Plan>) => {
      state.data = state.data
        ? [...state.data, action.payload]
        : [action.payload]
      state.loading = false
    })
    builder.addCase(addPlan.pending, (state) => {
      state.loading = true
    })
    builder.addCase(addPlan.rejected, (state) => {
      state.error = null
      state.loading = false
    })

    builder.addCase(
      updatePlan.fulfilled,
      (state, action: PayloadAction<UpdatePlanThunkParams>) => {
        const { id, body: updatedPlan } = action.payload
        if (!state.data) return
        const index = state.data.findIndex((item) => item.id === id)
        if (index !== -1) {
          state.data[index] = { ...state.data[index], ...updatedPlan }
        }
        state.loading = false
      },
    )
    builder.addCase(updatePlan.pending, (state) => {
      state.loading = true
    })
    builder.addCase(updatePlan.rejected, (state) => {
      state.error = null
      state.loading = false
    })

    builder.addCase(removePlan.fulfilled, (state, action) => {
      const id = action.payload
      if (!state.data) return
      const index = state.data.findIndex((item) => item.id === id)
      if (index !== -1) {
        state.data && state.data.splice(index, 1)
      }
      state.loading = false
    })
    builder.addCase(removePlan.pending, (state) => {
      state.loading = true
    })
    builder.addCase(removePlan.rejected, (state) => {
      state.error = null
      state.loading = false
    })
  },
})

export default plansSlice.reducer
